import { format, isToday, isYesterday } from "date-fns";

export function formatDate(date: Date): string {
    if (isToday(date)) {
      return `Today ${format(date, 'p')}`; // e.g. Today 2:02 PM
    } else if (isYesterday(date)) {
      return `Yesterday ${format(date, 'p')}`;
    } else {
      return format(date, 'dd/MM/yyyy p'); // e.g. 10/05/2025 1:30 PM
    }
  }